export default {
  title: 'Paramètres de pourboire',
  form: {
    has_tips: {
      label: 'Autoriser les pourboires',
    },
    default_tip_percentage: {
      label: 'Taux de pourboire présélectionné',
      tooltip: "Taux présélectionné pour le client sur l'écran de paiement",
    },
    is_tip_hidden_on_receipt: {
      label: 'Pourboires non visibles sur les reçus',
      tooltip: "Lorsqu'activé, masque les pourboires sur les reçus imprimés et dans la fenêtre d'info commande",
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement",
    changes_got_saved: 'Modifications enregistrées',
  },
};
